






















import clickOutside from 'v-click-outside'
import Component from 'vue-class-component'
import data from 'emoji-mart-vue-fast/data/apple.json'
import { datePickerMessages } from '@/i18n/cs'
import { Picker, EmojiIndex } from 'emoji-mart-vue-fast'
import { Prop, Watch } from 'vue-property-decorator'
import { removeInvalidChars } from '@/utils'
import { ValidationProvider } from 'vee-validate'
import Vue from 'vue'

@Component({
  components: { Picker, ValidationProvider },
  directives: { clickOutside: clickOutside.directive }
})
export default class TextAreaField extends Vue {
  innerValue?: string | null = null
  emojiVisible = false
  datePickerMessages = datePickerMessages
  emojiIndex = new EmojiIndex(data)

  @Prop({ type: String, required: false }) fieldId?: string
  @Prop({ type: String }) label?: string
  @Prop({ type: Number, required: false, default: Number.MAX_VALUE }) maxlength?: number
  @Prop({ type: String, required: false }) cssClass?: string
  @Prop({ type: String }) validation!: string
  @Prop({ type: Object, default: () => {} }) validationObj!: any
  @Prop({ type: String, default: '' }) value!: string
  @Prop({ type: Boolean, default: false }) showEmoji?: boolean
  @Prop({ type: Boolean, default: true }) showLabel!: boolean
  @Prop({ type: Boolean, required: false }) readonly?: boolean

  get requiredVal () {
    return ((this.validation || '').indexOf('required') >= 0) || (this.validationObj || {}).required
  }

  get emojiButtonSvgId () {
    return 'emojiButton-svg-' + this.fieldId
  }

  get emojiButtonPathId () {
    return 'emojiButton-path-' + this.fieldId
  }

  @Watch('innerValue')
  onInnerValueChange (value: string) {
    this.$emit('input', removeInvalidChars(value))
  }

  @Watch('value')
  onValueChange (value: string) {
    this.innerValue = removeInvalidChars(value)
  }

  addEmoji (emoji: any) {
    const textarea = this.$refs.textarea as HTMLTextAreaElement
    const cursorPosition = textarea.selectionEnd
    const start = this.value.substring(0, textarea.selectionStart)
    const end = this.value.substring(textarea.selectionStart)
    const text = start + emoji.native + end
    this.$emit('input', text)
    textarea.focus()
    this.emojiVisible = false
    this.$nextTick(() => {
      textarea.selectionEnd = cursorPosition + emoji.native.length
    })
  }

  // hide emoji picker when clicking outside of picker
  onClickOutside (event: any) {
    // do not hide emoji window when button is clicked
    if (event.target.id !== this.emojiButtonSvgId && event.target.id !== this.emojiButtonPathId) {
      this.emojiVisible = false
    }
  }

  created () {
    if (this.value) {
      this.innerValue = removeInvalidChars(this.value)
    }
  }
}
